import { createFileRoute } from '@tanstack/react-router';

import { TemplateLoading } from '@/_pages/companies/template/template-loading';

export const Route = createFileRoute('/_private/companies/_template')({
  pendingComponent: TemplateLoading,
});
